let swiperReview = null;

function init(container) {
	const $pagination = container.querySelector('.article-content-review__nav .swiper-pagination');
	let $sliderReview = container.querySelector('.js-slider-review');

	swiperReview = new Swiper($sliderReview, {
		slidesPerView: 1,
		centeredSlides: true,
		spaceBetween: 80,
		// loop: true,
		autoHeight: true,
		speed: 600,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		navigation: {
			nextEl: '.article-content-review__right',
			prevEl: '.article-content-review__left',
		},
		pagination: {
			el: $pagination,
			clickable: true,
		},
	});
}

function update() {
	if(swiperReview) {
		swiperReview.update();
	}
}

function destroy() {
	if (swiperReview) {
		swiperReview.destroy();
		swiperReview = null;
	}
}

export default {
	init,
	destroy,
	update
}
